const paymentTypeKey = (paymentType = {}) => paymentType?._id || paymentType?.name;

// Distributes a single sale line's total across its payment types in order,
// with the last type absorbing whatever remains, so any number of payment
// types is supported (not just the original hardcoded 2). A vale/store-credit
// discount is no longer part of this array (see store_credit_applied on Sale).
const distributeLineAmounts = (paymenttypes = [], unitPrice = 0, quantity = 1) => {
  const list = paymenttypes || [];
  let remaining = Math.max(Number(unitPrice) || 0, 0);

  const allocations = list.map((pt, idx) => {
    const isLast = idx === list.length - 1;
    const alloc = isLast
      ? Math.max(remaining, 0)
      : Math.min(Math.max(Number(pt?.amount) || 0, 0), remaining);
    remaining -= alloc;
    return alloc;
  });

  return list.map((pt, idx) => ({ ...pt, amount: allocations[idx] * (quantity || 1) }));
};

export { paymentTypeKey, distributeLineAmounts };
